enum VersionedPackage {
  ROBOTICS_SOFTWARE = 'ROBOTICS_SOFTWARE',
  DEBIAN_META_PACKAGE = 'DEBIAN_META_PACKAGE',
  MANAGEMENT_CONTAINERS = 'MANAGEMENT_CONTAINERS',
}

export default VersionedPackage;
